import React, { useState } from "react";
import { authHeader } from "../../../_helpers/auth-header";

import axiosInstance from "../../../_helpers/axiosConfig";

export default function ExportAction(props) {
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    setLoading(true);

    axiosInstance
      .request({
        headers: authHeader(),
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}/vaccine/schedule/${props.scheduleId}/export-token`,
      })
      .then(response => {
        setLoading(false);

        window.open(response.data.url);
      })
      .catch((error) => {
        setLoading(false);

        alert("Something went wrong please try again.");
      });
  }

  return <button
    onClick={handleExport}
    disabled={loading}
    type="button" className="btn btn-primary">{loading ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Export'}</button>;
}
